export default __webpack_public_path__ + "static/media/cleansingfire.43c48f47.png";